<template>
  <div class="parent">
    <div class="date"></div>
    <div class="chart">
      <div class="sales">
        <div>
          <h3>Total Daily Sales</h3>
          <CurrencyFormatter :value="daysTotal" :currency="currency" />
        </div>
      </div>
      <div class="payment layout">
        <h3>Payment Breakdown</h3>
        <table class="breakdown">
          <tbody>
            <tr v-for="(payment, index) in paymentLabels" :key="index">
              <td>{{ payment }}</td>
              <td><CurrencyFormatter :value="paymentData[index]" :currency="currency" /></td>
            </tr>
            <tr>
              <td>Total</td>
              <td><CurrencyFormatter :value="daysPayments" :currency="currency" /></td>
            </tr>
          </tbody>
        </table>
        <div>
          <button v-if="localSettings[0] && localSettings[0].float" @click.stop.prevent="showManagerCheck = true">Cash Up</button>
        </div>
        <ManagerCheckModal :isOpen="showManagerCheck" @close="showManagerCheck = false" @confirm="handleManagerConfirm" />
        <CashUpModal
          :open="showCashUpModal"
          :managerName="cashUpManagerName"
          :floatAmount="currentFloat"
          :floatAdjustments="recentFloatAdjustments"
          :paymentLabels="cashUpPaymentLabels"
          :paymentData="cashUpPaymentData"
          :todaysTotal="cashUpTotalPayments"
          :missedDays="missedDays"
          :lastCashUpDate="lastCashUpDate"
          @cash-up-completed="completeCashUp"
          @close="showCashUpModal = false" />
      </div>

      <div class="store-vs-store">
        <StoreVsStore />
      </div>
      <div class="line-graph">
        <LineChartParent />
      </div>
      <div class="stacked">
        <StackedBarChart />
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "@monolith/helpers";
import { mapGetters } from "vuex";
import { CurrencyFormatter, ManagerCheckModal } from "@monolith/components";
import Doughnut from "@/components/Totals/Doughnut.vue";
// import createdMixin from "@/components/_mixins/createdMixin";
import LineChartParent from "@/components/Totals/LineChartParent.vue";
import CashUpModal from "../Settings/CashUpModal.vue";
import StackedBarChart from "@/components/Totals/StackedBarChart.vue";
import StoreVsStore from "@/components/Totals/StoreVsStore.vue";
//  import LineChartBonus from "@/components/Totals/LineChartBonus.vue";
//   import Datepicker from '@vuepic/vue-datepicker';
import "@vuepic/vue-datepicker/dist/main.css";
import Slug from "slug";

export default {
  name: "ChartParent",
  // mixins: [createdMixin],
  components: { Doughnut, LineChartParent, CashUpModal, CurrencyFormatter, StackedBarChart, ManagerCheckModal, StoreVsStore },
  props: [],
  data() {
    return {
      daysTotal: 0,
      daysPayments: 0,
      paymentLabels: [],
      paymentData: [],
      recentFloatAdjustments: [],
      currentFloat: 0,
      salesLabels: [],
      salesData: [],
      dayDate: new Date(),
      showCashUpModal: false,
      showManagerCheck: false,
      cashUpManagerName: "",
      missedDays: 0,
      lastCashUpDate: null,
      cashUpPaymentLabels: [],
      cashUpPaymentData: [],
      cashUpTotalPayments: 0,
    };
  },
  setup() {
    //     // In case of a range picker, you'll receive [Date, Date]
    //     const format = (dayDate) => {
    //     const day = dayDate.getDate();
    //     const month = dayDate.getMonth() + 1;
    //     const year = dayDate.getFullYear();
    //     return `Selected date is ${day}/${month}/${year}`;
    //     }
    //     const endDate= () => {
    //         return new Date()
    //     }
    //     return {
    //         format,
    //         endDate
    //     }
  },
  async mounted() {
    this.getPayments();
    const staff = await api.get_employees(localStorage.getItem("company"));
    this.$store.dispatch("training/setEmployees", staff);
  },

  computed: {
    ...mapGetters({
      localSettings: "localSettings",
      siteSettings: "siteSettings",
      currency: "currency",
    }),
  },

  watch: {
    dayDate() {
      this.getPayments();
    },
  },
  methods: {
    async handleManagerConfirm(manager) {
      this.cashUpManagerName = `${manager.value.firstName} ${manager.value.lastName}`;
      this.showManagerCheck = false;
      await this.openCashUpModal();
    },

    completeCashUp(cashUpData) {
      this.showCashUpModal = false;
      const station = Slug(this.localSettings[0].name);
      const now = Date.now();

      // Always record cash sales as a credit (carries the drawer balance forward)
      /***if (cashUpData.cashSales > 0) {
        this.channel.push("document:new", {
          _id: `float:${now}`,
          station,
          doc_type: "credit",
          name: cashUpData.name,
          timestamp: new Date().toISOString(),
          value: cashUpData.cashSales,
        });
      }***/

      // Record the manual adjustment if one was made
      if (cashUpData.adjustmentType) {
        this.channel.push("float:new", {
          _id: `float:${now + 1}`,
          station,
          doc_type: cashUpData.adjustmentType,
          name: cashUpData.name,
          timestamp: new Date().toISOString(),
          value: cashUpData.adjustmentAmount,
          reason: cashUpData.adjustmentType === "debit" ? cashUpData.adjustmentReason : "",
        });
      }

      // Audit trail when no cash sales and no adjustment
      if (cashUpData.cashSales <= 0 && !cashUpData.adjustmentType) {
        this.channel.push("float:new", {
          _id: `float:${now}`,
          station,
          doc_type: "credit",
          name: cashUpData.name,
          timestamp: new Date().toISOString(),
          value: 0,
        });
      }
    },

    checkBagels() {
      if (window.localStorage.getItem("company") === "bagels") {
        return true;
      } else {
        return false;
      }
    },

    async openCashUpModal() {
      this.showCashUpModal = !this.showCashUpModal;
      let floatAmount = await api.get_station_float(localStorage.getItem("site"), Slug(this.localSettings[0].name), true);
      let adjustments = await api.get_station_float(localStorage.getItem("site"), Slug(this.localSettings[0].name));
      this.currentFloat = floatAmount.rows[0].value;
      this.recentFloatAdjustments = adjustments.rows.map((adj) => adj);

      // Detect missed cash-ups
      const lastAdj = this.recentFloatAdjustments[0];
      if (lastAdj && lastAdj.doc && lastAdj.doc.timestamp) {
        const lastDate = new Date(lastAdj.doc.timestamp);
        const today = new Date();
        lastDate.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);
        const diffMs = today.getTime() - lastDate.getTime();
        this.missedDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
        this.lastCashUpDate = lastAdj.doc.timestamp;
      } else {
        this.missedDays = 0;
        this.lastCashUpDate = null;
      }

      // Fetch payments covering all missed days (or just today)
      await this.getCashUpPayments();
    },

    async getCashUpPayments() {
      let start;
      if (this.missedDays > 0 && this.lastCashUpDate) {
        // Start from the day after the last cash-up
        const dayAfterLast = new Date(this.lastCashUpDate);
        dayAfterLast.setDate(dayAfterLast.getDate() + 1);
        dayAfterLast.setHours(0, 0, 0, 0);
        start = dayAfterLast;
      } else {
        start = new Date();
        start.setHours(0, 0, 0, 0);
      }
      const end = new Date();
      end.setHours(23, 59, 59, 0);

      let payments = await this.apiCall("payments", start.toISOString().substring(0, 13), end.toISOString().substring(0, 13), true, 2);

      this.cashUpTotalPayments = payments.rows.reduce((acc, p) => acc + p.value, 0);

      if (this.cashUpTotalPayments === 0) {
        this.cashUpPaymentLabels = ["No Payments"];
        this.cashUpPaymentData = [0];
        return;
      }

      const reduced = this.reducerByKey(payments);
      this.cashUpPaymentLabels = Object.keys(reduced).map((l) => l.charAt(0).toUpperCase() + l.slice(1));
      this.cashUpPaymentData = Object.values(reduced);
    },

    async apiCall(type, startDate, endDate, group, group_level) {
      return await api.get(`/api/reports/${type}/${localStorage.getItem("site")}?group=${group}&group_level=${group_level}&start_key=["${startDate}"]&end_key=["${endDate}"]`);
    },
    async getSales(startDate, endDate) {
      // const totals = await this.apiCall('sales', startDate, endDate, true, 0)
      // totals.rows.length > 0 ? this.daysTotal = totals.rows[0].value : this.daysTotal = 0;

      let catSales = await this.apiCall("sales", startDate, endDate, true, 2);
      this.daysTotal = catSales.rows.reduce((acc, sale) => {
        return acc + sale.value;
      }, 0);

      catSales = this.reducerByKey(catSales);
      this.salesLabels = Object.keys(catSales);
      this.salesLabels = this.salesLabels.map((label) => {
        return label.charAt(0).toUpperCase() + label.slice(1);
      });
      this.salesData = Object.values(catSales);
    },
    async getPayments() {
      let start = new Date(this.dayDate.setHours(0, 0, 0));
      let end = new Date(this.dayDate.setHours(23, 59, 59));

      let payments = await this.apiCall("payments", start.toISOString().substring(0, 13), end.toISOString().substring(0, 13), true, 2);
      this.daysPayments = payments.rows.reduce((acc, payment) => {
        return acc + payment.value;
      }, 0);

      payments.rows.sort((a, b) => {
        if (a.key[1] < b.key[1]) return -1;
        if (a.key[1] > b.key[1]) return 1;
        return 0;
      });

      this.getSales(start.toISOString().substring(0, 13), end.toISOString().substring(0, 13));

      if (this.daysPayments === 0) {
        this.paymentLabels = ["No Payments"];
        this.paymentData = [0];
        return;
      }
      this.todaysPayments = this.reducerByKey(payments);
      this.paymentLabels = Object.keys(this.todaysPayments);
      this.paymentLabels = this.paymentLabels.map((label) => {
        return label.charAt(0).toUpperCase() + label.slice(1);
      });
      this.paymentData = Object.values(this.todaysPayments);
    },
    reducerByKey(reduceArray) {
      const reducedArray = reduceArray.rows.reduce((acc, payment) => {
        const value = acc[payment.key[1]] || 0;
        return { ...acc, [payment.key[1]]: value + payment.value };
      }, {});
      return reducedArray;
    },
  },
};
</script>

<style scoped lang="scss">
.parent {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .seperator {
    border-left: 3px solid rgb(154, 158, 161);
    height: 400px;
  }
  .chart {
    width: 80vw;
    display: grid;
    grid-template-areas:
      "sales line-graph"
      "payment payment"
      "breakdown breakdown"
      "stacked stacked"
      "store-vs-store store-vs-store";
    flex-direction: column;
    //align-items: center;
    justify-content: normal;
    gap: 10px;

    .line-graph {
      grid-area: line-graph;
      background-color: var(--secondary-colour);
      border-radius: 1rem;
    }
    .stacked {
      grid-area: stacked;
    }
    .store-vs-store {
      grid-area: store-vs-store;
    }
    .layout {
      grid-area: breakdown;
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 1rem;
      background-color: var(--secondary-colour, 0.25);
      border-radius: 1rem;
      .breakdown {
        width: 400px;
        tr {
          td {
            width: 100px;
          }
        }
        tr:last-child {
          font-weight: bold;
          text-decoration: underline;
        }
      }
    }
    .payment {
      grid-area: payment;
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 1rem;
      gap: 10px;
      justify-content: center;
      background-color: var(--secondary-colour);
      border-radius: 1rem;
      h3 {
        padding: 0;
        margin: 0 auto;
      }

      h2 {
        padding: 0;
        margin: 0 auto;
        font-weight: bold;
      }
    }

    .sales {
      grid-area: sales;
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 10px;
      justify-content: center;
      background-color: var(--secondary-colour);
      border-radius: 1rem;
      height: 100%;
      h3 {
        padding: 0;
        margin: 0 auto;
      }

      h2 {
        padding: 0;
        margin: 0 auto;
        font-weight: bold;
      }
    }
    .bonus:hover {
      transform: rotateY(180deg);
      transition: transform 0.5s;
    }
    .bonus {
      grid-area: bonus;
      transition: transform 1s;
      transform-style: preserve-3d;
      align-items: center;
      justify-content: center;
      background-color: var(--secondary-colour);
      border-radius: 1rem;
      margin-bottom: 2rem;
      height: 60rem;
      .front,
      .back {
        backface-visibility: hidden;
        width: 100%;
        text-align: center;
        position: absolute;
      }
      .back {
        transform: rotateY(180deg);
      }
      h3 {
        vertical-align: middle;
      }

      h2 {
        padding: 0;
        margin: 0 auto;
        font-weight: bold;
      }
    }
  }
  .date {
    width: 100%;
  }

  .totals {
    display: flex;
    flex-direction: row;
    gap: 10px;
  }
}

@media only screen and (orientation: portrait) {
  .chart {
    display: flex !important;
    flex-direction: column;
    .layout {
      max-width: 80vw;
    }
    .sales {
      max-width: 80vw;
      min-height: 10rem;
    }
  }
}
</style>
